import { useEffect, useState } from "react";
import { useParams, Link, useOutletContext } from "react-router-dom";
import api from "@/lib/api";
import { JournalCard } from "@/components/JournalCard";
import { PaperCard } from "@/components/PaperCard";
import { Loader2, ChevronRight } from "lucide-react";

export default function CategoryPage() {
  const { slug } = useParams();
  const { settings } = useOutletContext();
  const hideIF = settings?.show_impact_factor === false;
  const [cat, setCat] = useState(null);
  const [papers, setPapers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/categories/${slug}`).then(({ data }) => setCat(data)).finally(() => setLoading(false));
    api.get(`/papers?category=${slug}&limit=8`).then(({ data }) => setPapers(data)).catch(() => {});
  }, [slug]);

  if (loading) return <div className="min-h-[50vh] grid place-items-center"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>;
  if (!cat) return <div className="max-w-7xl mx-auto px-6 py-20">Category not found.</div>;

  return (
    <div>
      <div className="bg-primary text-white">
        <div className="max-w-7xl mx-auto px-6 py-14">
          <div className="flex items-center gap-2 text-sm text-slate-400 mb-3">
            <Link to="/" className="hover:text-amber-400">Home</Link>
            <ChevronRight className="w-4 h-4" />
            <span className="text-slate-300">Subjects</span>
          </div>
          <h1 className="font-serif font-black text-4xl md:text-5xl">{cat.name}</h1>
          <p className="mt-4 text-slate-300 max-w-2xl">{cat.description}</p>
        </div>
      </div>

      <section className="max-w-7xl mx-auto px-6 py-16">
        <h2 className="font-serif font-bold text-2xl mb-6 text-slate-900 dark:text-slate-100">Journals in this discipline</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {cat.journals?.map((j) => <JournalCard key={j.slug} journal={j} hideImpactFactor={hideIF} />)}
        </div>
        {cat.journals?.length === 0 && <p className="text-slate-500">No journals yet in this category.</p>}

        {papers.length > 0 && (
          <>
            <h2 className="font-serif font-bold text-2xl mt-16 mb-6 text-slate-900 dark:text-slate-100">Recent articles</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {papers.map((p) => <PaperCard key={p.id} paper={p} />)}
            </div>
          </>
        )}
      </section>
    </div>
  );
}
